import React, { useState, useEffect, useRef } from 'react';
import api from "../../../services/api";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CommonHighchartsAsync } from '../Ecg/CommonHighchartsAsync'


export function HRChart({ displayName, data, chartName, requestUrl }) {
  const { t } = useTranslation();


  const chartRef = useRef(null);
  
  //const yAxisSettings = [{ title: { text: 'HR, bpm' }, labels: { format: '{value} bpm' }, opposite: false }];

  const chartOptions = {
    title: {
      text: t('recordView.processedData.charts.hrChart.header')
    },
    xAxis: {
      maxRange: undefined,
      tickPositioner: undefined,
      tickInterval: undefined,
      minorTicks: false,
      minorTickInterval: undefined
    },
    yAxis: {
      min: 25,
      max: 260,
      //startOnTick: false,
      //endOnTick: false,
      title: { text: '' }, labels: { format: '{value}' }, opposite: false
    },
    tooltip: {
      valueDecimals: 0,
      valueSuffix: ' bpm'
    },
  };

  const navigatorOptions = {
    xAxis: {
      maxRange: 6 * 3600000,
      range: 1 * 3600000
    }
  };

  useEffect(() => {
    //console.log(displayName);

    if (data) {

      //let min = Math.min(...data.map(x => x[1]));
      //let max = Math.max(...data.map(x => x[1]));

      //chartRef.current.setupYAxis(yAxisSettings);
      //chartRef.current.setInitialData(data);
      chartRef.current.setInitialData([]);
      chartRef.current.setInitialDataForLongSeries(data.longRecord, requestUrl);      
      //chartRef.current.setChartExtremesX(data[data.length - 1][0], 0);
      //chartRef.current.setChartExtremesYMinMax(min, max);
    }
  }, []);


 

  return (
    <>
      <h3>{displayName}</h3>
      <CommonHighchartsAsync ref={chartRef} seriesName={'HR'} chartOptions={chartOptions} navigatorOptions={navigatorOptions} />            
    </>
  );
}

